var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-form',{ref:"form",attrs:{"autocomplete":"off"}},[_c('v-col',[_c('address-picker',{attrs:{"detail-mode":true,"min-characters":4},model:{value:(_vm.location),callback:function ($$v) {_vm.location=$$v},expression:"location"}})],1),_c('v-col',[_vm._v("Value:"+_vm._s(_vm.location))])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }